<div class="date-picker-modal">
    <finder-calendar
        class="calendar"
        [(date)]="selectedDate"
        (dateSelected)="onDateChanged($event)">
    </finder-calendar>
    <finder-button theme="primary" (click)="dismiss()">{{data.labels.datePickerButton}}</finder-button>
</div>
